// extracted by mini-css-extract-plugin
export default {"calculator":"Calculator_calculator__WfAiq","icon":"Calculator_icon__0RywB"};